import { hrmsSupabase } from '../../../services/supabase';
import { Tleaves } from '../../../types/analyticsTypes';

export const getLeaves = async (
  startDate: string,
  endDate: string,
  team?: string,
  employeeId?: string,
): Promise<{
  leaves: Tleaves[];
  error: Error | null;
}> => {
  let query = hrmsSupabase
    .from('leaves')
    .select('start_date, end_date, employee_id, status, employees!inner(team)')
    .or(
      `and(start_date.gte.'${startDate}T00:00:00',start_date.lte.'${endDate}T23:59:59'),` + // Starts within range
        `and(end_date.gte.'${startDate}T00:00:00',end_date.lte.'${endDate}T23:59:59'),` + // Ends within range
        `and(start_date.lte.'${startDate}T00:00:00',end_date.gte.'${endDate}T23:59:59')`, // Spans across range
    );

  if (team) {
    query = query.eq('employees.team', team);
  }

  if (employeeId) {
    query = query.eq('employee_id', employeeId);
  }

  const { data: leaves, error: leavesError } = await query;

  if (leavesError) {
    return {
      leaves: [],
      error: new Error('Error fetching leaves'),
    };
  }
  return {
    leaves: leaves as unknown as Tleaves[],
    error: leavesError,
  };
};
